module.exports = "\r\n.margin-top{\r\n    margin-top: 24px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-grid/fixed-allowance-grid.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-grid/fixed-allowance-grid.component.css
// module chunks = main